"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "lit";
import { property, query } from "lit/decorators.js";
import { STCComponentMixin } from "../../../common/mixins/stc_component_mixin";
import { GroupChangeController } from "./controllers/group_change_controller";
import { SchoolBrandingController } from "./controllers/school_branding_controller";
import * as $ from "jquery";
export class StcCRMBar extends STCComponentMixin(LitElement) {
  constructor() {
    super();
    this.schoolBrandingController = new SchoolBrandingController(this);
  }
  updated(_changedProperties) {
    if (_changedProperties.has("currentSchool")) {
      this.schoolBrandingController.hostUpdated();
    }
  }
  moveCustomContent() {
    const leftCustomContent = this.querySelector('[slot="left-slot-controls"]');
    const leftCustomContentSlot = this.querySelector('[slot="left-controls"]');
    if (leftCustomContent && leftCustomContentSlot) {
      while (leftCustomContent.firstChild) {
        leftCustomContentSlot.appendChild(leftCustomContent.firstChild);
      }
      leftCustomContent.remove();
    }
    const customContent = this.querySelector('[slot="right-slot-controls"]');
    const customContentSlot = this.querySelector('[slot="right-controls"]');
    if (customContent && customContentSlot) {
      while (customContent.firstChild) {
        customContentSlot.appendChild(customContent.firstChild);
      }
      customContent.remove();
    }
  }
  firstUpdated(_changedProperties) {
    this.moveCustomContent();
    this.groupChangeController = new GroupChangeController(this, this.authConfig);
  }
  renderLogo() {
    return html`
      <div slot="logo">
        <hi-image class="mt-3" aesthetic="icon" src="/images/eab_navigate360_logo.svg" alt="EAB Navigate360 Logo" height="27" width="152">
        </hi-image>
        <span class="application_title title_divider crm">|</span>
        <span class="application_title title_text crm">${this.crmContextTitle}</span>
      </div>
    `;
  }
  renderCenterControls() {
    if (!this.loggedIn) return html``;
    return html`
      <div class="top-nav__center-controls" slot="center-controls">
        <stc-quick-search
          ?ignoreGroups=${this.searchConfig.ignoreGroups}
          .quickSearchUrl=${this.urls.quickSearch}
          .emptyMessage=${this.searchConfig.emptyMessage}
          .defaultPlaceholderMessage=${this.searchConfig.placeholderMessage}
          .formAuthenticityToken=${this.authConfig.formAuthenticityToken}
          ?can-search-contacts=${this.searchConfig.canSearchContacts}
          ?can-search-households=${this.searchConfig.canSearchHouseholds}
          ?can-search-organizations=${this.searchConfig.canSearchOrganizations}
          ?can-search-prospects=${this.searchConfig.canSearchProspects}
          ?quick-search-filter-enabled=${this.searchConfig.quickSearchFilterEnabled}>
        </stc-quick-search>
      </div>
    `;
  }
  renderLeftControls() {
    if (!this.loggedIn) return html``;
    return html`
      <div class="top-nav__left-controls" slot="left-controls"></div>
    `;
  }
  renderRightControls() {
    if (!this.loggedIn) return html``;
    return html`
      <div slot="right-controls">
        ${this.renderGroupsDropdown()}
      </div>
    `;
  }
  renderGroupsDropdown() {
    const isSchoolPresent = !!this.currentSchool;
    const hasMultipleGroups = this.currentUser?.groups?.length > 1;
    const isGroupSelected = !!this.currentGroup;
    const hasNonStudentProfessorRole = this.currentUser?.user_types?.some(
      (type) => type !== "student" && type !== "professor"
    );
    const shouldRenderDropdown = isSchoolPresent && isGroupSelected && hasMultipleGroups && hasNonStudentProfessorRole;
    if (!shouldRenderDropdown) {
      return html``;
    }
    const truncate = (str, length, escape = false) => {
      if (str.length <= length) return str;
      const truncated = str.slice(0, length) + "...";
      return escape ? truncated.replace(/</g, "&lt;").replace(/>/g, "&gt;") : truncated;
    };
    const groups = this.currentUser.groups.map((group) => ({
      name: truncate(group.name, 30),
      id: group.id,
      selected: group.id === this.currentGroup.id
    }));
    return html`
      <hi-label for="top-nav__groups" class="mll mrm mt-2 pt-5">Groups</hi-label>
      <hi-dropdown id="top-nav__groups" class="top-nav__groups mt-4" aesthetic="tight" cap-height>
        <hi-select id="top-nav__groups-select" aesthetic="dropdown" @value-changed=${this.__handleGroupChange}>
          ${groups.map((group) => html`
            <hi-option value="${group.id}" ?selected="${group.selected}">
              ${group.name}
            </hi-option>
          `)}
        </hi-select>
      </hi-dropdown>
    `;
  }
  __getCurrentSchoolId() {
    return this.currentSchool ? this.currentSchool.id : void 0;
  }
  __getCurrentGroupId() {
    if (this.currentSchool && this.currentGroup && this.currentUser.groups.length > 1 && this.currentUser.can_choose_a_group) {
      return this.currentGroup.id;
    }
    return null;
  }
  __handleGroupChange(event) {
    const currentGroupId = this.__getCurrentGroupId();
    const selectedGroupId = event.detail.value;
    if (currentGroupId !== selectedGroupId) {
      this.groupChangeController.updateGroupAndReload(window["select_school_group_path"](this.__getCurrentSchoolId(), selectedGroupId));
    }
  }
  __secondaryEventHandler(e) {
    if (e.detail.value.title === "Stop Impersonation") {
      const formData = new FormData();
      formData.append("authenticity_token", this.authConfig.formAuthenticityToken);
      fetch(e.detail.value.uri, {
        method: e.detail.value.method,
        body: formData
      }).then((response) => {
        if (response.status !== 200) {
          return;
        }
        if (e.detail.value.callback) {
          e.detail.value.callback();
        }
        if (e.detail.value.reload) {
          window.location.reload(true);
        }
      });
    } else if (e.detail.value.title === "User Settings") {
      $.get(e.detail.value.uri, function(data) {
        GF.loadUserPreferencesForm(data);
      });
      const flyout = $("hi-navigation-secondary")[0].shadowRoot.querySelector("hi-flyout#accountAvatar__flyout");
      flyout.close();
    }
  }
  render() {
    if (!this.loggedIn) return html``;
    const initials = `${this.currentUser.first_name?.[0] || ""}${this.currentUser.last_name?.[0] || ""}`;
    const theme = this.authConfig.isImpersonating ? "red" : "";
    const title = "Profile Help Menu";
    const accountAvatar = {
      initials,
      pictureURI: this.pictureURI,
      theme,
      title
    };
    const accountActions = [];
    if (!_.isEmpty(this.urls.admin)) {
      accountActions.push({
        title: this.navigationTabsAdmin,
        href: this.urls.admin,
        ...this.urls.adminNewTab ? { external: true, target: "_blank" } : {}
      });
    }
    if (!_.isEmpty(this.urls.updatePassword)) {
      accountActions.push({ title: "Update Password", href: this.urls.updatePassword });
    }
    if (!_.isEmpty(this.urls.userSettings)) {
      accountActions.push({ title: "User Settings", href: "#", uri: this.urls.userSettings });
    }
    if (!_.isEmpty(this.urls.notificationSettings)) {
      accountActions.push({ title: "In-App Notification Settings", href: this.urls.notificationSettings });
    }
    if (!_.isEmpty(this.urls.contentTemplates)) {
      accountActions.push({ title: "Content Templates", href: this.urls.contentTemplates });
    }
    if (!_.isEmpty(this.urls.stopImpersonation) && this.authConfig.isImpersonating) {
      accountActions.push({ title: "Stop Impersonation", href: "#", uri: this.urls.stopImpersonation, method: "DELETE", callback: window["GF"].sanitizeDialogs, reload: true });
    } else if (!_.isEmpty(this.urls.logout)) {
      accountActions.push({ title: "Logout", href: this.urls.logout });
    }
    if (!_.isEmpty(this.urls.login) && !this.loggedIn) {
      accountActions.push({ title: "Login", href: this.urls.login });
    }
    return html`
      <hi-navigation-primary theme="university" x-region="navigation-primary">
        ${this.currentSchool ? this.currentSchool.name.toUpperCase() : ""}
      </hi-navigation-primary>
      <hi-navigation-secondary @account-action-ended="${this.__secondaryEventHandler}" accessibility-tools x-region="navigation-secondary" .accountActions=${accountActions} .accountAvatar=${accountAvatar}>
        ${this.renderLogo()}
        ${this.renderLeftControls()}
        ${this.searchConfig.canQuickSearch && this.renderCenterControls()}
        ${this.renderRightControls()}
      </hi-navigation-secondary>
    `;
  }
}
__decorateClass([
  property({ type: Boolean, attribute: "logged-in" })
], StcCRMBar.prototype, "loggedIn", 2);
__decorateClass([
  property({ type: Object, attribute: "current-user" })
], StcCRMBar.prototype, "currentUser", 2);
__decorateClass([
  property({ type: Object, attribute: "current-school" })
], StcCRMBar.prototype, "currentSchool", 2);
__decorateClass([
  property({ type: Object, attribute: "current-group" })
], StcCRMBar.prototype, "currentGroup", 2);
__decorateClass([
  property({ type: Object, attribute: "urls" })
], StcCRMBar.prototype, "urls", 2);
__decorateClass([
  property({ type: Object, attribute: "search-config" })
], StcCRMBar.prototype, "searchConfig", 2);
__decorateClass([
  property({ type: Object, attribute: "auth-config" })
], StcCRMBar.prototype, "authConfig", 2);
__decorateClass([
  property({ type: String, attribute: "crm-context-title" })
], StcCRMBar.prototype, "crmContextTitle", 2);
__decorateClass([
  property({ type: String, attribute: "picture-uri" })
], StcCRMBar.prototype, "pictureURI", 2);
__decorateClass([
  property({ type: String, attribute: "navigation-tabs-admin" })
], StcCRMBar.prototype, "navigationTabsAdmin", 2);
__decorateClass([
  query("hi-navigation-primary")
], StcCRMBar.prototype, "primaryNavEl", 2);
customElements.define("stc-bar-component", StcCRMBar);
